import {
	TextureLoader,
	SpriteMaterial,
	Sprite
} from 'three';

// draw a "label"
// (my word, we're labelling axes and datapoints with SVGs, loaded as THREE.js Sprites)
// `labelPath` is a String, a path to the image file to load on disk
// `position` and `scale` are both Array<3 Number>s
// `position` gives the x,y,z position of the label
// `scale` gives the x,y,z dimensions (I think?) of it
// returns a THREE.Sprite,  complete with a location/scale, ready to be added to a Scene
export default function drawLabel( labelPath, position, scale ) {
	const map = new TextureLoader().load( labelPath );
	const material = new SpriteMaterial( { map: map } );
	const sprite = new Sprite( material );
	sprite.scale.set( ...scale );
	sprite.position.set( ...position );
	return sprite;
}
